import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { Badge } from "../ui/badge";
import { useState } from "react";
import { Star } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { JobCardHeader } from "./JobCardHeader";
import { JobDetails } from "./JobDetails";


interface JobCardProps {
  job: {
    id: string;
    title: string;
    company: string;
    location: string;
    type: string;
    description: string;
    seniority: string;
    salary_range: string;
    contract_type: string;
    application_url?: string;
    logo_url?: string;
    isCurated?: boolean;
    isFeatured?: boolean;
  };
}

export function JobCard({ job }: JobCardProps) {
  const [isApplying, setIsApplying] = useState(false);
  

  const handleApply = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (job.isCurated) {
        // Registrar clique em vaga curada
        await supabase.from('curated_job_application_clicks').insert({
          curated_job_id: job.id,
          user_id: user?.id || null,
          clicked_at: new Date().toISOString()
        });
        await supabase.rpc('increment_curated_application_clicks', { curated_job_id_param: job.id });
      } else {
        // Registrar clique em vaga normal
        await supabase.from('job_application_clicks').insert({
          job_id: job.id,
          user_id: user?.id || null,
          clicked_at: new Date().toISOString()
        });
        await supabase.rpc('increment_application_clicks', { job_id_param: job.id });
      }
    } catch (error) {
      console.error('Erro ao registrar clique em candidatar:', error);
    }

    if (job.application_url) {
      window.open(job.application_url, '_blank');
    }
  };

  const handleAddViewToJob = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();

      if (job.isCurated) {
        // Registrar view de vaga curada
        await supabase.from('curated_job_views').insert({
          curated_job_id: job.id,
          user_id: user?.id || null,
          viewed_at: new Date().toISOString(),
          referrer: document.referrer || null,
          user_agent: navigator.userAgent
        });
        await supabase.rpc('increment_curated_job_views', { curated_job_id_param: job.id });
      } else {
        // Registrar view de vaga normal
        await supabase.from('job_views').insert({
          job_id: job.id,
          user_id: user?.id || null,
          viewed_at: new Date().toISOString(),
          referrer: document.referrer || null,
          user_agent: navigator.userAgent
        });
        await supabase.rpc('increment_job_views', { job_id_param: job.id });
      }
      
      
      console.log('View registrada com sucesso');
    } catch (err) {
      console.error('Erro ao registrar view:', err);
    }
  };


  return (
    <div className={`bg-white rounded-lg shadow-md p-4 md:p-6 hover:shadow-lg transition-shadow w-full max-w-2xl mx-auto relative ${job.isFeatured ? 'border-2 border-yellow-400 ring-1 ring-yellow-200' : ''}`}>
      {job.isFeatured && (
        <Badge className="absolute -top-2.5 left-4 bg-yellow-400 text-yellow-900 hover:bg-yellow-400 text-xs font-semibold gap-1">
          <Star className="h-3 w-3 fill-yellow-900" />
          Em Destaque
        </Badge>
      )}
      <JobCardHeader job={job} />

      <Dialog >
        <DialogTrigger asChild>
          <Button
            onClick={handleAddViewToJob}
            className="w-full mt-4 bg-[#7779f5] hover:bg-[#7779f5]/90 text-white transition-colors text-sm md:text-base"
          >
            Ver vaga
          </Button>
        </DialogTrigger>
        <DialogContent className="max-w-[95%] md:max-w-2xl p-4 md:p-6 max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-xl md:text-2xl font-bold text-[#1e293b]">{job.title}</DialogTitle>
          </DialogHeader>
          <div className="mt-4 space-y-4">
            <JobDetails job={job} />

            <Button
              onClick={handleApply}
              className="w-full mt-6 bg-[#7779f5] hover:bg-[#7779f5]/90 text-white transition-colors flex items-center justify-center gap-2"
            >
              Quero me candidatar
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}